'use client';

import { useEffect } from 'react';

import {
  storeOutreachRef,
  readBrowserStorage,
  takeSessionClickOnce,
  isOutreachTrackedPath,
  getOrCreateOutreachSid,
  parseOutreachIdFromSearch,
} from 'src/utils/outreach/outreach-ref';

import { reportOutreachClick } from 'src/actions/outreach';

// ----------------------------------------------------------------------

/**
 * 영업 메일 링크(`?cm=<historyId>`)로 들어온 것을 admin 발송 이력에 보고한다 — **그리는 것은 없다**.
 *
 * `AnalyticsProvider` 가 그려 **어느 화면으로 들어와도** 잡힌다(메일 본문의 링크는 홈만이 아니다).
 * 표식은 30일 보관(먼저 온 값이 이긴다 — 가입 보고가 읽는다)하고, 유입 보고는 **세션당 한 번**만 보낸다.
 * 주소는 손대지 않는다 — 쿼리를 지우면 새로고침이 다른 유입으로 보인다. 수신거부 화면은 세지 않는다(`isOutreachTrackedPath`).
 * 활동 로그 한 줄(`outreach_landed`)은 따로다(`lib/analytics/outreach-landing`).
 */
export function OutreachClickTracker() {
  useEffect(() => {
    if (!isOutreachTrackedPath(window.location.pathname)) return;
    const historyId = parseOutreachIdFromSearch(window.location.search);
    if (!historyId) return;

    const local = readBrowserStorage('local');
    if (local) storeOutreachRef(local, historyId);

    const session = readBrowserStorage('session');
    if (session && !takeSessionClickOnce(session, historyId)) return;

    void reportOutreachClick({
      historyId,
      url: window.location.href,
      ref: document.referrer || undefined,
      sid: local ? getOrCreateOutreachSid(local) : undefined,
    });
  }, []);

  return null;
}
